<template>
	<div
		class="textfield position-relative"
		:class="!mlUnset && id != 'tagconfiguration' && id != 'ml-unset' && 'ml-3'"
	>
		<label v-if="showLabel" class="d-flex mb-1"
			>{{ text }}

	<span v-if="id == 'sectionreveal'" class="text-h2 fs-12  fc-c-blue" style="font-style: italic; line-height:20px;">(in days)</span>
			<span v-show="isMandatory" class="asterik">*</span>


			</label
		>
		<div class="w-100 position-relative">
			<b-skeleton v-if="showLoader" height="38px"></b-skeleton>
			<template v-else>
				<b-form-input
					@keypress="validateInput"
					:placeholder="placeholder"
					v-model="modelValue[modelKey]"
					:disabled="disabled"
					@keyup.enter="$emit('enter')"
					:class="{
						error: error,
						'pd-right': type === 'password',
						'pd-green-tick': modelKey == 'newPswd',
					}"
					@input="$emit('input')"
					:formatter="formatInput"
					:type="type"
					:maxlength="maxLength"
					:max="max"
					autocomplete="new-password"
				></b-form-input>
				<template v-if="modelKey === '$model'">
					<span
						v-if="!modelValue.required && modelValue.$dirty"
						class="required-font top-38px"
						>Required</span
					>
					<span
						v-if="modelValue.$dirty && modelValue.maxLength === false"
						class="required-font top-38px"
						>Maximum {{ maxLength }} character</span
					>
				</template>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: "TextField",
	props: {
		id: {
			type: String,
			default: null,
		},
		showLoader: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: "text",
		},
		text: {
			type: String,
			default: "",
		},
		placeholder: {
			type: String,
			default: "Enter",
		},
		modelValue: {
			type: Object,
			required: true,
		},
		modelKey: {
			type: String,
			required: true,
		},
		isMandatory: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		error: {
			type: Boolean,
			default: false,
		},
		maxLength: {
			type: Number,
			required: false,
		},
		showLabel: {
			type: Boolean,
			default: true,
		},
		mlUnset: {
			type: Boolean,
			default: false,
		},
		numericOnly: {
			type: Boolean,
			default: false,
		},
		max: {
			type: Number,
			default: null,
		},
	},
	methods: {
		validateInput(event) {
			if (!this.numericOnly) return;

			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);

			// allow numbers only
			if (!/[0-9]/.test(charTyped)) {
				event.preventDefault();
			}
		},
		formatInput(value) {
			if (this.max !== null && value !== "" && value !== null) {
				const numericValue = Number(value);

				if (!isNaN(numericValue) && numericValue > this.max) {
					return String(this.max);
				}
			}
			return value;
		},
	},
};
</script>

<style>
.top-38px {
	top: 38px;
}
.pd-right {
	padding-right: 20px !important;
}
.pd-green-tick {
	padding-right: 40px !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

input[type="number"] {
	-moz-appearance: textfield;
}
</style>
